export default function isTranslatedDoc(translationInfo) {
    if (!translationInfo) {
        return false;
    }
    return translationInfo.sourceLang !== translationInfo.targetLang;
}
